import React, { memo, Fragment } from 'react'
import map from 'ramda/src/map'
import Title from 'root/src/client/web/typography/Title'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPaperPlane } from '@fortawesome/pro-regular-svg-icons/faPaperPlane'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from './styles'

const WhatIsDaredrop = memo(({ pageContent, classes }) => {
	const { title, text } = pageContent

	return (
		<div className={classes.contactsWrapper}>
			<Title>
				<span style={{ textTransform: 'upperCase' }}>
					{title}
				</span>
			</Title>
			<FontAwesomeIcon icon={faPaperPlane} size="3x" style={{ margin: 10 }} />
			<div className={classes.strWrapper}>
				{map(([txt, anchor]) => (
					<Fragment key={txt}>
						<span className={classes.text}>{txt}</span>
						<a href={anchor.href} className={classes.link}>
							{anchor.label}
						</a><br />
					</Fragment>
				), text)}
			</div>
		</div>
	)
})

export default withStyles(styles, { name: 'MuiContacts' })(WhatIsDaredrop)
